module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show && _vm.isipx) ? _c('div', {
    staticClass: ["wrapper-ipx"],
    style: {
      'background-color': _vm.bgColor || 'transparent',
      'border-top-color': _vm.borderTopColor || 'transparent'
    }
  }) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-5a9876d8!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-ipx-bar/index.vue
// module id = 615
// module chunks = 0 1